"use client";

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { FlexColumn, Separator, SideSheetBody, SideSheetHeader, SideSheetHeaderTitle, TextLabel, UnstyledButton } from "@opensea/ui-kit";
import { ExpandMore } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useEffect, useState } from "react";
import { FormProvider, useForm, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../components/Button";
import { WalletAddressInput } from "../../../components/WalletAddressInput";
import { useAddressInputField } from "../../../hooks/useAddressInput";
import { useChainId } from "../../../polychain/hooks/useChainId";
import { FlowActions } from "../../../stores/flowStore";
import { Sending } from "./components/Sending";
import { SendReview } from "./components/SendReview";
import { TokenQuantityInput } from "./components/TokenQuantityInput";
import { useTransferTokens } from "./hooks/useTransferTokens";
import { useSendQuote } from "./provider/SendProvider";
import { sendFlowFormSchema } from "./schema";
export const SendFlowContent = t0 => {
  const $ = _c(94);
  const {
    onBack
  } = t0;
  const t = useTranslations("wallet.SendFlow");
  const chainId = useChainId();
  const [container, setContainer] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [actions, setActions] = useState(t1);
  const {
    currency
  } = useSendQuote();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mode: "onChange",
      defaultValues: {
        quantity: undefined,
        recipient: {
          identifier: "",
          resolvedAddress: undefined,
          isResolving: false
        }
      },
      resolver: zodResolver(sendFlowFormSchema)
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const form = useForm(t2);
  const {
    handleSubmit,
    control
  } = form;
  let t3;
  if ($[2] !== control) {
    t3 = {
      control
    };
    $[2] = control;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    isValid
  } = useFormState(t3);
  let t4;
  if ($[4] !== control) {
    t4 = {
      control,
      name: "quantity"
    };
    $[4] = control;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const quantity = useWatch(t4);
  let t5;
  if ($[6] !== control) {
    t5 = {
      control,
      name: "recipient"
    };
    $[6] = control;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const recipient = useWatch(t5);
  let t6;
  if ($[8] !== currency || $[9] !== quantity) {
    t6 = quantity ? bn(quantity).times(currency.usdPrice).toString() : "";
    $[8] = currency;
    $[9] = quantity;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const quantityUsd = t6;
  let t7;
  if ($[11] !== form.setValue || $[12] !== recipient.identifier) {
    t7 = {
      field: "recipient",
      setValue: form.setValue,
      identifier: recipient.identifier
    };
    $[11] = form.setValue;
    $[12] = recipient.identifier;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const addressInputProps = useAddressInputField(t7);
  let t8;
  let t9;
  if ($[14] !== currency || $[15] !== quantity) {
    t8 = () => {
      FlowActions.setFlowField("currency", currency);
      FlowActions.setFlowField("amount", quantity);
    };
    t9 = [currency, quantity];
    $[14] = currency;
    $[15] = quantity;
    $[16] = t8;
    $[17] = t9;
  } else {
    t8 = $[16];
    t9 = $[17];
  }
  useEffect(t8, t9);
  const transferTokens = useTransferTokens();
  let t10;
  if ($[18] !== currency || $[19] !== transferTokens) {
    t10 = async data => {
      if (!data.recipient.resolvedAddress) {
        throw new Error("No profile address");
      }
      const actions_0 = await transferTokens({
        chain: currency.chainIdentifier,
        contractAddress: currency.contractAddress,
        quantity: data.quantity,
        toAddress: data.recipient.resolvedAddress
      });
      if (!actions_0) {
        throw new Error("No actions");
      }
      setActions(actions_0);
    };
    $[18] = currency;
    $[19] = transferTokens;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== handleSubmit || $[22] !== t10) {
    t11 = handleSubmit(t10);
    $[21] = handleSubmit;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const onSubmit = t11;
  if (!chainId) {
    FlowActions.endFlow();
  }
  if (actions.length > 0 && addressInputProps.resolvedAddress) {
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = () => {
        setActions([]);
      };
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t13;
    if ($[25] !== actions || $[26] !== addressInputProps.ensName || $[27] !== addressInputProps.imageUrl || $[28] !== addressInputProps.resolvedAddress || $[29] !== currency || $[30] !== quantity) {
      t13 = <Sending actions={actions} address={addressInputProps.resolvedAddress} currency={currency} ensName={addressInputProps.ensName} imageUrl={addressInputProps.imageUrl} onBack={t12} quantity={quantity} />;
      $[25] = actions;
      $[26] = addressInputProps.ensName;
      $[27] = addressInputProps.imageUrl;
      $[28] = addressInputProps.resolvedAddress;
      $[29] = currency;
      $[30] = quantity;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    return t13;
  }
  let t12;
  if ($[32] !== onBack || $[33] !== t) {
    t12 = onBack && <UnstyledButton onClick={onBack}><ExpandMore className="rotate-90" size={24} title={t("back")} /></UnstyledButton>;
    $[32] = onBack;
    $[33] = t;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t) {
    t13 = t("title");
    $[35] = t;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t13) {
    t14 = <SideSheetHeaderTitle>{t13}</SideSheetHeaderTitle>;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== t12 || $[40] !== t14) {
    t15 = <SideSheetHeader className="gap-4">{t12}{t14}</SideSheetHeader>;
    $[39] = t12;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Separator />;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t) {
    t17 = t("tokenSelectedLabel");
    $[43] = t;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t17) {
    t18 = <TextLabel color="text-secondary">{t17}</TextLabel>;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== container) {
    t19 = <TokenQuantityInput container={container} />;
    $[47] = container;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t18 || $[50] !== t19) {
    t20 = <FlexColumn className="relative gap-4">{t18}{t19}</FlexColumn>;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t) {
    t21 = t("recipientWalletLabel");
    $[52] = t;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== t21) {
    t22 = <TextLabel color="text-secondary">{t21}</TextLabel>;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== form) {
    t23 = value => form.setValue("recipient.identifier", value);
    $[56] = form;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== form) {
    t24 = form.register("recipient.identifier");
    $[58] = form;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== addressInputProps || $[61] !== t23 || $[62] !== t24) {
    t25 = <WalletAddressInput setValue={t23} {...addressInputProps} {...t24} />;
    $[60] = addressInputProps;
    $[61] = t23;
    $[62] = t24;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== t22 || $[65] !== t25) {
    t26 = <FlexColumn className="relative gap-4">{t22}{t25}</FlexColumn>;
    $[64] = t22;
    $[65] = t25;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== t20 || $[68] !== t26) {
    t27 = <FlexColumn className="gap-10">{t20}{t26}</FlexColumn>;
    $[67] = t20;
    $[68] = t26;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] !== currency || $[71] !== quantity || $[72] !== quantityUsd) {
    t28 = <SendReview currency={currency} priceUSD={currency.usdPrice} quantity={quantity} quantityUsd={quantityUsd} total={quantityUsd} />;
    $[70] = currency;
    $[71] = quantity;
    $[72] = quantityUsd;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  const t29 = !(isValid && recipient.resolvedAddress);
  let t30;
  if ($[74] !== t) {
    t30 = t("sendButton");
    $[74] = t;
    $[75] = t30;
  } else {
    t30 = $[75];
  }
  let t31;
  if ($[76] !== currency.symbol || $[77] !== quantity) {
    t31 = <span className="font-normal">{quantity} {currency.symbol}</span>;
    $[76] = currency.symbol;
    $[77] = quantity;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== onSubmit || $[80] !== t29 || $[81] !== t30 || $[82] !== t31) {
    t32 = <Button className="font-mono" disabled={t29} onClick={onSubmit}>{t30}{" "}{t31}</Button>;
    $[79] = onSubmit;
    $[80] = t29;
    $[81] = t30;
    $[82] = t31;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== t28 || $[85] !== t32) {
    t33 = <FlexColumn className="gap-6">{t28}{t32}</FlexColumn>;
    $[84] = t28;
    $[85] = t32;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== t27 || $[88] !== t33) {
    t34 = <SideSheetBody className="flex grow flex-col justify-between gap-10 p-6" ref={setContainer}>{t27}{t33}</SideSheetBody>;
    $[87] = t27;
    $[88] = t33;
    $[89] = t34;
  } else {
    t34 = $[89];
  }
  let t35;
  if ($[90] !== form || $[91] !== t15 || $[92] !== t34) {
    t35 = <FormProvider {...form}>{t15}{t16}{t34}</FormProvider>;
    $[90] = form;
    $[91] = t15;
    $[92] = t34;
    $[93] = t35;
  } else {
    t35 = $[93];
  }
  return t35;
};